import {put, takeLatest, call} from 'redux-saga/effects';
import * as paymentService from "../../../services/paymentService";
import {
    PURCHASE_BY_SAVED_CARD,
    PURCHASE_BY_SAVED_CARD_SUCCESS,
    PURCHASE_BY_SAVED_CARD_ERROR,
}
    from "../../actions/payment"

function* purchaseBySavedCardSaga(action) {
    try {
       const data  = yield call(paymentService.PurchaseBySavedCard,action.payload)
       yield put({
        type: PURCHASE_BY_SAVED_CARD_SUCCESS,
        payload: data
    })


    } catch (error) {
        yield put({
            type: PURCHASE_BY_SAVED_CARD_ERROR,error: error.data
        })
    }
}


export function* purchaseBySavedCardSagaWatcher() {
    yield takeLatest(PURCHASE_BY_SAVED_CARD, purchaseBySavedCardSaga)
}